
import React, { Component } from 'react';
import { loadJS } from '@platform/api';

/**
 * 第三方组件
 */
class NCThirdCom extends Component {

    state = { component: null, errorMsg: '' };

    componentDidMount() {
        let { componentNameSpace, componentPath } = this.props;
        if (componentPath && componentNameSpace) {
            loadJS(
                componentPath,
                () => {
                    try {
                        let component = window[componentNameSpace].default;
                        this.setState({ component });
                    } catch (e) { console.log('加载失败', e);}
                },
                () => {
                    this.setState({ errorMsg: '加载失败' });
                },
            );
        }
    }

    render() {
        const { component } = this.state;
        const { showThirdComponent, _dev, componentName, showPlaceHolder } = this.props;
        let devDom = showPlaceHolder ? <div style={{ width: '100%', height: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{componentName}</div> : null;
        return (
            <React.Fragment>
                {(component && showThirdComponent && !_dev) ? (React.createElement(component, { ...this.props })) : devDom}
            </React.Fragment>
        );
    }
}

export default NCThirdCom;
